import { createReducer, on } from '@ngrx/store';
import {
	deleteUser,
	deleteUserError,
	deleteUserSuccess,
	getUser,
	getUserError,
	getUserSuccess,
	postUser,
	postUserError,
	postUserSuccess,
	searchUser,
	searchUserError,
	searchUserSuccess,
	updateUser,
	updateUserError,
	updateUserSuccess,
} from './users.actions';
import { initialStateUsers } from './users.state';
import adapterDataPagination from '../../../Domain/Adapters/pagination.adapter';

export const reducerUsers = createReducer(
	initialStateUsers,
	on(getUserSuccess, searchUserSuccess, (state, { user, pagination }) => ({
		...state,
		users: user,
		pagination: adapterDataPagination(pagination),
		paginationInit: pagination,
		error: null,
		loading: false,
	})),
	on(postUserSuccess, (state, { user }) => ({
		...state,
		users: [user, ...state.users],
		pagination: adapterDataPagination(
			state.paginationInit,
			state.users.length,
			+1,
			state.pagination.total,
			state.pagination.pageTo
		),
		error: null,
		loading: false,
	})),
	on(updateUserSuccess, (state, { user }) => ({
		...state,
		users: state.users.map((userItem) => (userItem.username === user.username ? user : userItem)),
		error: null,
		loading: false,
	})),
	on(deleteUserSuccess, (state, { user }) => {
		const users = [...state.users];
		user.forEach((userElement) => {
			const userIndex = users.findIndex(
				(index) => index.sk === userElement.sk && index.pk === userElement.pk
			);
			users.splice(userIndex, 1);
		});

		return {
			...state,
			loading: false,
			users,
			pagination: adapterDataPagination(
				state.paginationInit,
				state.users.length,
				-user.length,
				state.pagination.total,
				state.pagination.pageTo
			),
			error: null,
		};
	}),
	on(
		getUserError,
		deleteUserError,
		postUserError,
		updateUserError,
		searchUserError,
		(state, { error }) => ({
			...state,
			loading: false,
			error: error.error.errorMessage,
		})
	),
	on(getUser, deleteUser, postUser, updateUser, searchUser, (state) => ({
		...state,
		loading: true,
	}))
);
